/*
 * @Descripttion: axios网络请求封装
 */

import axios from 'axios'
import qs from 'qs'

const API_ROOT = process.env.VUE_APP_API_ROOT

export default {
  install(Vue) {
    let gotoLogin
    let toast

    Vue.prototype._injectToLogin = function (func) {
      gotoLogin = func
    }
    Vue.prototype._injectToToast = function (func) {
      toast = func
    }

    /**
     * @typedef Result
     * @property {Object} data 返回数据中的data对象
     * @property {Object} errorCode 调用失败时返回数据中的code属性
     * @property {Object} errorRaw 调用失败时返回的原始数据
     */

    /**
     * 以 await/async 方式发起POST请求
     * @param url {string}
     * @param data {Object}
     * @param autoToast {boolean} 是否在错误时自动toast
     * @return {Result}
     */
    Vue.prototype.postAsync = async function (url, data, autoToast = true) {
      const token = sessionStorage[process.env.VUE_APP_TOKEN]
      try {
        const result = await axios.post(API_ROOT + url, data, {
          headers: {
            Authorization: token,
          },
        })

        if (result.data.code !== 1) {
          if (autoToast) {
            if ('/business/shipAffairs/monthCheckCrew/stockMonthCheck' != url) {
              toast.error(result.data.msg)
            }
            // toast.error(result.data.msg)
          }
          if (result.data.code === 2000) {
            gotoLogin()
          }
          return {
            errorCode: result.data.code,
            errorRaw: result.data,
          }
        }
        return {
          data: result.data.data,
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          if (autoToast) {
            toast.error('接口不存在')
          }
          return {
            error: err.response.data.data,
            errorRaw: {
              ...err.response.data,
              msg: '接口不存在',
            },
          }
        } else {
          console.log(err.response)
          toast.error(err.response ? '未知错误' : '网络错误')
          toast.error(err.response.data.data)
          return {
            error: {},
            errorRaw: {
              code: -1,
              msg: err.response ? '未知错误' : '网络错误',
            },
          }
        }
      }
    }

    /**
     * 以 await/async 方式发起GET请求
     * @param url {string}
     * @param data {Object}
     * @param autoToast {boolean} 是否在错误时自动toast，默认true
     * @return {Result}
     */
    Vue.prototype.getAsync = async function (url, data, autoToast = true) {
      const token = sessionStorage[process.env.VUE_APP_TOKEN]
      try {
        const result = await axios.get(API_ROOT + url, {
          params: data,
          paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false })
          },
          headers: {
            Authorization: token,
          },
        })

        if (result.data.code !== 1) {
          if (autoToast) {
            toast.error(result.data.msg)
          }
          if (result.data.code === 2000) {
            gotoLogin()
          }
          return {
            errorCode: result.data.code,
            errorRaw: result.data,
          }
        }
        return {
          data: result.data.data,
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          if (autoToast) {
            toast.error('接口不存在')
          }
          return {
            error: err.response.data.data,
            errorRaw: {
              ...err.response.data,
              msg: '接口不存在',
            },
          }
        } else {
          console.log(err.response)
          toast.error(err.response ? '未知错误' : '网络错误')
          return {
            error: {},
            errorRaw: {
              code: -1,
              msg: err.response ? '未知错误' : '网络错误',
            },
          }
        }
      }
    }

    /**
     * 获取图片arraybuffer
     * @param url {string}
     * @param data {Object}
     * @return {arraybuffer}
     */
    Vue.prototype.getArrayBuffer = async function (url, data) {
      const token = sessionStorage[process.env.VUE_APP_TOKEN]
      try {
        const result = await axios.get(API_ROOT + url, {
          params: data,
          paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false })
          },
          headers: {
            Authorization: token,
          },
          responseType: 'arraybuffer',
        })
        return result
      } catch (err) {
        console.log(err)
        return { errorRaw: err }
      }
    }

    /**
     * 用post FormData对象传输单个文件
     * @param url {string} URL
     * @param data {file} 数据源文件，自动转为formData对象
     * @return {Result}
     */
    Vue.prototype.postFormData = async function (url, data) {
      const token = sessionStorage[process.env.VUE_APP_TOKEN]
      let formData = new FormData()
      formData.append('file', data)
      try {
        const result = await axios.post(API_ROOT + url, formData, {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
        })
        return {
          data: result.data.data,
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          return {
            error: err.response.data.data,
            errorRaw: {
              ...err.response.data,
              msg: '接口不存在',
            },
          }
        } else {
          return {
            error: {},
            errorRaw: {
              code: -1,
              msg: err.response ? '未知错误' : '网络错误',
            },
          }
        }
      }
    }

    Vue.prototype.blobDownload = async function (url, data, fileName) {
      const token = sessionStorage[process.env.VUE_APP_TOKEN]
      try {
        const result = await axios.post(API_ROOT + url, data, {
          responseType: 'blob',
          headers: {
            Authorization: token,
          },
        })
        if (result.code === 0) {
          toast.error('文件下载错误')
          return
        }
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([result.data]))
        link.download =
          fileName ||
          decodeURIComponent(
            result.headers['content-disposition'].split('=')[1],
          )
        document.body.appendChild(link)
        link.click()
        return {}
      } catch (err) {
        console.log(err)
        if (err.response && err.response.status === 404) {
          toast.error('文件链接不存在或无权下载')
          return {
            error: err.response.data.data,
            errorRaw: {
              ...err.response.data,
              msg: '文件下载失败',
            },
          }
        } else {
          toast.error('文件链接不存在或无权下载')
          return {
            error: {},
            errorRaw: {
              code: -1,
              msg: err.response ? '未知错误' : '网络错误',
            },
          }
        }
      }
    }
    Vue.prototype.getBlobDownload = async function (url, data, fileName) {
      const token = sessionStorage[process.env.VUE_APP_TOKEN]
      try {
        const result = await axios.get(API_ROOT + url, {
          params: data,
          paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false })
          },
          responseType: 'arraybuffer',
          headers: {
            Authorization: token,
          },
        })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([result.data]))
        link.download =
          fileName ||
          decodeURIComponent(
            result.headers['content-disposition'].split('=')[1],
          )
        document.body.appendChild(link)
        link.click()
        return {}
      } catch (err) {
        console.log(err)
        if (err.response && err.response.status === 404) {
          toast.error('文件链接不存在或无权下载')
          return {
            error: err.response.data.data,
            errorRaw: {
              ...err.response.data,
              msg: '文件下载失败',
            },
          }
        } else {
          toast.error('文件链接不存在或无权下载')
          return {
            error: {},
            errorRaw: {
              code: -1,
              msg: err.response ? '未知错误' : '网络错误',
            },
          }
        }
      }
    }
  },
}
